export const COMPANY = {
  name: "Chowat Security Services Inc.",
  short: "Chowat Security",
  email: "chwtscrt@gmail.com",
  phone: "(604) 316-7945",
  phoneHref: "tel:+16043167945",
  logo: "/images/logo-red-transparent.png",
  slogan: "Protecting people, property, and the land we come from.",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Our Values", href: "#values" },
  { label: "Training & Safety", href: "#training" },
  { label: "Contact", href: "#contact" },
];
